import { useEffect, useRef } from "react";
import { useSignIn } from "@clerk/react/legacy";
import { isNativeShell, requestNative } from "@/lib/native-shell";

export function NativeShellBridge() {
  const { signIn, setActive } = useSignIn();
  const busy = useRef(false);
  useEffect(() => {
    const click = (event: MouseEvent) => {
      if (!isNativeShell()) return;
      const button = (event.target as HTMLElement)?.closest?.("button");
      if (!button || !(
        button.className.includes("cl-socialButtons") ||
        /choose google account/i.test(button.textContent ?? "")
      )) return;
      // Providers do not permit embedded user-agent authentication. Start a
      // fresh first-party browser flow, rather than copying their redirect URL.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy.current) return;
      busy.current = true;
      void requestNative("auth:start").catch((error: Error) => window.alert(error.message))
        .finally(() => { busy.current = false; });
    };
    const ticket = (event: Event) => {
      const value = (event as CustomEvent).detail;
      if (!isNativeShell() || value?.nonce !== window.__plateNativeNonce || !signIn || !setActive) return;
      void (async () => {
        try {
          const result = await signIn.create({ strategy: "ticket", ticket: value.ticket });
          if (result.status !== "complete" || !result.createdSessionId) throw new Error("Session not complete");
          await setActive({ session: result.createdSessionId });
          // Existing site guards still decide onboarding, intake, and access.
          window.location.assign(import.meta.env.BASE_URL);
        } catch {
          window.alert("App sign-in did not complete. Please start sign-in again.");
        }
      })();
    };
    document.addEventListener("click", click, true);
    window.addEventListener("plate-native-ticket", ticket);
    return () => {
      document.removeEventListener("click", click, true);
      window.removeEventListener("plate-native-ticket", ticket);
    };
  }, [signIn, setActive]);
  return null;
}